import { css } from '@emotion/react';
import { fontFamily } from '@atlaskit/theme';

export default css`
  box-sizing: border-box;

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  input {
    font-family: ${fontFamily()};
    margin: 0;
  }
`;
